module.exports = __webpack_public_path__ + "img/cd.7798ea60.svg";